'use client';

import { MarketType } from '@velocity-exchange/sdk';
import { getMaxLeverageForMarket } from '@velocity-exchange/common';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

const DEFAULT_STATE = {
	maxLeverage: 0,
};

const useMarketMaxLeverage = (
	marketType: MarketType,
	marketIndex: number | undefined
) => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const driftClientIsReady = useDriftClientIsReady();

	if (
		!driftClientIsReady ||
		!driftClient ||
		!driftClient.isSubscribed ||
		marketIndex === undefined
	) {
		return DEFAULT_STATE;
	}

	const { maxLeverage } = getMaxLeverageForMarket(
		marketType,
		marketIndex,
		driftClient
	);

	return {
		maxLeverage,
	};
};

export default useMarketMaxLeverage;
